import { Stack } from 'react-bootstrap'
import { Field } from '@ztechapps/webui.form'
import { CompanySelect } from '@ztechapps/company.webui'
import { InlineDisplayContent, PhoneNumberInput, UserFormValidate } from '@ztechapps/webui.input'
import React, { useState } from 'react'
import { Alert, ShowIf } from '@ztechapps/webui.util'
import { useField } from 'formik'

export const CustomerFormLayout = ({ readOnlyCompany = false }: { readOnlyCompany?: boolean }) => {
  const [companyField] = useField('company')

  const onChangeOfCompany = (e, _meta, fieldProps) => {
    setCompanyWasChanged(true)
    fieldProps.form.setFieldValue('company', e)
  }
  const [companyWasChanged, setCompanyWasChanged] = useState(false)

  return (
    <Stack gap={2}>
      <Stack className="justify-content-start">
        {readOnlyCompany ? (
          <InlineDisplayContent label="Company">{companyField?.value?.name}</InlineDisplayContent>
        ) : (
          <Field
            name="company"
            component={CompanySelect}
            label="Company"
            help="Update the company for this contact."
            onChange={onChangeOfCompany}
            showInfo={true}
          />
        )}
        <ShowIf condition={companyWasChanged}>
          <Alert
            type="info"
            text={`You’re changing the company for this contact. Once saved, the contact will be moved to ${companyField?.value?.label ?? ''}. If that’s not what you want, you may want to choose a different customer.`}
          />
        </ShowIf>
      </Stack>

      <Field name="profile.name" label="Contact Name" help="Contact name" />
      <Field name="profile.email" label="Contact Email" help="Contact primary email" />
      <Field name="phone" component={PhoneNumberInput} label="Phone" help="Contact primary phone" />
    </Stack>
  )
}

export const CustomerFormValidate = UserFormValidate
